import { t } from "i18next";
import { lazy, object, string } from "yup";

export const phoneNumberSchema = object().shape({
  phone_number: lazy((value) => {
    switch (typeof value) {
      case "string":
        return string()
          .trim()
          .required(t("Please enter a valid phone number."));
      default:
        return object()
          .shape({
            number: string().required(t("Please enter a valid phone number.")),
            national_number: string(),
            country: string(),
            calling_code: string(),
          })
          .required(t("Please enter a valid phone number."));
    }
  }),
});
